<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
import {
  driverDetail,
  // carSearchList,
} from 'api/archives';
import {
  getEnumList,
  getCarTypeList,
} from 'api';
export default {
  data () {
    return {
      loginAcctTimer: null,
      otherFormData: {
        userId: '', // 用户id
        vehicleCode: '', // 车辆编码
      },
      baseForm: {
        vehicleStatusOptions: [],
        licenceTypeOptions: [],
        carOptions: [],
        form: [
          {
            label: '司机账号',
            value: 'loginAcct',
            type: 'input',
            onChange: (loginAcct) => {
              clearTimeout(this.loginAcctTimer);
              this.loginAcctTimer = setTimeout(async () => {
                const res = await driverDetail({
                  loginAcct,
                });
                for (let i = 0; i < this.baseForm.form.length; i++) {
                  if (this.baseForm.form[i].value === 'linkman') {
                    this.baseForm.form[i].disabled = Boolean(res.userId);
                  }
                  if (this.baseForm.form[i].value === 'car') {
                    this.baseForm.form[i].hide = !res.userId;
                  }
                  if (this.baseForm.form[i].value === 'plateNumber') {
                    this.baseForm.form[i].hide = Boolean(res.userId);
                  }
                }
                if (!res.failed && res.userId) { // 有这个司机
                  this.otherFormData.userId = res.userId;
                  this.$refs.baseForm.setVal('linkman', res.linkman); // 司机姓名
                  const carList = res.vehicleDataInfoList.map((item) => ({ // 车辆
                    label: item.plateNumber,
                    value: item.plateNumber,
                    originData: item,
                  }));
                  this.baseForm.carOptions = [
                    ...carList,
                    {
                      label: '其他车辆',
                      value: -1,
                    },
                  ];
                  this.$refs.baseForm.setVal('car', this.baseForm.carOptions[0].value);
                  this.$refs.baseForm.setVal('plateNumber', this.baseForm.carOptions[0].value);
                  this.handleCarSelect(this.baseForm.carOptions[0].value);
                } else {
                  this.$refs.baseForm.setVal('plateNumber', '');
                  this.handleCarSelect(-1);
                }
              }, 500);
            },
          },
          {
            label: '司机姓名',
            value: 'linkman',
            type: 'input',
          },
          // 已有司机
          {
            label: '选择车辆',
            value: 'car',
            type: 'select',
            hide: true,
            onChange: (val) => {
              this.handleCarSelect(val);
            },
          },
          // 已有司机 end
          // 无找到对应车辆
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
          },
          {
            label: '牌照类型',
            value: 'licenceType',
            type: 'select',
            onChange: () => {
              this.handleLicenceType();
            },
          },
          {
            label: '车辆类型',
            value: 'vehicleStatus',
            type: 'cascader',
            normal: true,
            default: [],
          },
          // 无找到对应车辆 end
          {
            label: '车辆载重',
            value: 'vehicleLoad',
            type: 'show',
            hide: true,
          },
          {
            label: '车辆容积',
            value: 'lightGoodsSquare',
            type: 'show',
            hide: true,
          },
          {
            label: '归属车队',
            value: 'tenantName',
            type: 'show',
            hide: true,
          },
        ],
        rules: {
          loginAcct: [ // 司机账号
            { required: true, message: '请输入司机账号', trigger: 'blur' },
          ],
          linkman: [ // 司机姓名
            { required: true, message: '请输入司机姓名', trigger: 'blur' },
          ],
          car: [ // 选择车辆
            { required: true, message: '请选择车辆', trigger: 'blur' },
          ],
          plateNumber: [ // 车牌号码
            { required: true, message: '请输入车牌号码', trigger: 'blur' },
          ],
          licenceType: [ // 牌照类型
            { required: true, message: '请选择牌照类型', trigger: 'blur' },
          ],
          vehicleStatus: [ // 车辆类型
            { required: true, message: '请选择车辆类型', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleLicenceType () {
      const licenceType = this.$refs.baseForm.getVal('licenceType');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: licenceType === '2',
        names: ['vehicleStatus'],
      });
    },
    async getList () {
      const enumsList = await getEnumList({
        codeType: 'LICENCE_TYPE',
      });
      this.baseForm.licenceTypeOptions = enumsList[0];
      this.baseForm.vehicleStatusOptions = await getCarTypeList();
    },
    handleCarSelect (val) {
      // 控制表单相关显示隐藏
      const showArr = ['vehicleLoad', 'lightGoodsSquare', 'tenantName'];
      const disabledArr = ['licenceType', 'vehicleStatus'];
      for (let i = 0; i < this.baseForm.form.length; i++) {
        if (showArr.indexOf(this.baseForm.form[i].value) !== -1) {
          this.baseForm.form[i].hide = val === -1;
        }
        if (disabledArr.indexOf(this.baseForm.form[i].value) !== -1) {
          this.baseForm.form[i].disabled = val !== -1;
        }
        if (this.baseForm.form[i].value === 'plateNumber') {
          this.baseForm.form[i].hide = val !== -1;
        }
      }
      // 控制表单相关显示隐藏 end
      if (val === -1) { // 其他车辆
        return;
      }
      let carData = {};
      for (let i = 0; i < this.baseForm.carOptions.length; i++) {
        if (this.baseForm.carOptions[i].value === val) {
          carData = this.baseForm.carOptions[i].originData;
          break;
        }
      }
      // 牌照类型
      this.$refs.baseForm.setVal('vehicleStatus', [
        String(carData.vehicleStatus),
        String(carData.vehicleLength),
      ]);
      // 牌照类型
      this.$refs.baseForm.setVal('licenceType', String(carData.licenceType));
      // 车辆载重
      this.$refs.baseForm.setVal('vehicleLoad', carData.vehicleLoad);
      // 车辆容积
      this.$refs.baseForm.setVal('lightGoodsSquare', carData.lightGoodsSquare);
      // 归属车队
      this.$refs.baseForm.setVal('tenantName', carData.tenantName);
      this.otherFormData.vehicleCode = carData.vehicleCode;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          userId: this.otherFormData.userId,
          vehicleCode: this.otherFormData.vehicleCode,
          loginAcct: formData.loginAcct, // 司机账号
          linkman: formData.linkman, // 司机姓名
          plateNumber: formData.plateNumber, // 车牌号码
          licenceType: formData.licenceType, // 牌照类型
          vehicleLoad: formData.vehicleLoad, // 车辆载重
          lightGoodsSquare: formData.lightGoodsSquare, // 车辆容积
          vehicleStatus: formData.vehicleStatus[0], // 车辆类型
          vehicleLength: formData.vehicleStatus[1], // 车辆类型
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const res = await this.handleSubData();
      return res;
    },
    init (data = {}) {
      this.otherFormData.userId = data.userId;
      this.otherFormData.vehicleCode = data.vehicleCode;
      this.$refs.baseForm.setVal('loginAcct', data.loginAcct || '');
      this.$refs.baseForm.setVal('linkman', data.linkman || '');
      this.$refs.baseForm.setVal('car', data.car || '');
      this.$refs.baseForm.setVal('plateNumber', data.plateNumber || '');
      this.$refs.baseForm.setVal('licenceType', data.licenceType || '');
      let vehicleStatus = [];
      if (data.vehicleStatus) {
        vehicleStatus = [
          String(data.vehicleStatus),
          String(data.vehicleLength),
        ];
      }
      this.$refs.baseForm.setVal('vehicleStatus', vehicleStatus);
      this.$refs.baseForm.setVal('vehicleLoad', data.vehicleLoad || '');
      this.$refs.baseForm.setVal('lightGoodsSquare', data.lightGoodsSquare || '');
      this.$refs.baseForm.setVal('tenantName', data.tenantName || '');
      this.handleLicenceType();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
